import styles from './Style.module.css'
import { getInitials } from '../../../Utils/utils';
import ShowerIcon from '../../../Components/Icons/ShowerIcon';

const RoomCard = ({ room }) => {

  // console.log("roomCard room", room);
  // const itemLength = room?.items?.length;

  const displayRoomCode = () => {
    if (!room?.room_code) return 'N/A';
    // If room_code is a string (not a number), show initials
    if (typeof room.room_code === 'string' && isNaN(room.room_code)) {
      return getInitials(room.room_code);
    }
    // Otherwise show as is (numbers, etc.)
    return room.room_code;
  };

  const displayRoomName = () => {
    if (!room?.room_name) return 'N/A';
    // Remove leading numbers and spaces
    return room.room_name.replace(/^\d+\s*/, '').trim() || 'N/A';
  };

  return (
      <div className={styles.roomCard}>
        <div className={styles.topOuter}>
          <div className={styles.top} title={displayRoomName()}>
            <div className={`${styles.left} random-color-room-code`}>
              {displayRoomCode()}
            </div>
              {Array.isArray(room?.items) && room.items.some((item) =>
                Array.isArray(item.facilities) &&
                item.facilities.some((facility) => String(facility).toLowerCase() === 'shower')
              ) && (
                <div className={`${styles.left} random-color-room-code`}><ShowerIcon size={16} color="white" /></div>
              )}
            <div className={styles.right}>
              <h4>{displayRoomName()}</h4>
              {/* <h4>{room?.item_category}</h4> */}
            </div>
          </div>
          {/* <div className={styles.topBottom}>
              <h5>{displayRoomName()}</h5>
              <h6>{itemLength} item{itemLength > 1 && 's'}</h6>
          </div> */}
        </div>
        <div className={`${styles.bottom} ${room?.items.length > 1 ? styles.couplesRoomCell : ''}`}>
          {room?.items.length > 0 && room?.items.map((item) => (
            <div className={styles.item} key={item?.item_id} title={item?.item_name}>
              <h6>{item?.item_name}</h6>
            </div>))}
        </div>
      </div>
  )
}

export default RoomCard
